/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-syntax */
import { MenuItemLateral } from 'src/layouts/layout-privado/sidebar/Sidebar';
import { Roles } from 'src/utils/roles/roles';
import { menuLateralGestion } from './menu-lateral-gestion';
import { menuLateralReportes } from './menu-lateral-reportes';

export enum ItemMenuId {
	GESTION = 'GESTION',
	REPORTES = 'REPORTES',
	ADMINISTRACION = 'ADMINISTRACION',
}

export type ItemMenu = {
	id: ItemMenuId;
	text: string;
	route: string;
	icon?: string;
	rolesConAcceso: Roles[];
    menuLateral: MenuItemLateral[];
};
// Opciones para el menú de navegación
const opcionMenuGestion: ItemMenu = {
	id: ItemMenuId.GESTION,
	text: 'Gestión',
	route: '/gestion',
	icon: 'dashboard',
	rolesConAcceso: [Roles.ADMIN, Roles.GESTOR],
    menuLateral: menuLateralGestion
};



export const opcionesMenuGeneral: ItemMenu[] = [
	opcionMenuGestion,
];


export const obtenerPrimerItemConRuta = (
	menu: MenuItemLateral[],
): MenuItemLateral | null => {
	for (const item of menu) {
		if (item.path) {
			return item;
		}
		if (item.items) {
			const ruta = obtenerPrimerItemConRuta(item.items);
			if (ruta) {
				return ruta;
			}
		}
	}
	return null;
}

export interface ValoresPathDinamico {
	key: string;
	valor: string;
}

export const buscarMenuLateral = (menu: ItemMenu[], ruta?: string | null) => {
	let menuLateral: MenuItemLateral[] = [];
	if(ruta) {
		menu.forEach((m) => {
			if (m.route === ruta) {
				menuLateral = m.menuLateral
			}
		})
	}else {
		menuLateral = menu[0].menuLateral
	}
	return menuLateral
}

export const obtenerOpcionesSegunRol = (
	rolActivo: string,
	valoresDinamicos: ValoresPathDinamico[]
) => {
	const opcionesMenu = opcionesMenuGeneral
		.filter((opcion) => opcion.rolesConAcceso.includes(rolActivo as Roles))
		.map((opcion) => ({
			...opcion,
			menuLateral: obtenerOpcionesMenuLateral(opcion.menuLateral, rolActivo as Roles).map((item) =>
				agregarRutaDinamica(item, valoresDinamicos)
			),
		}));

	return opcionesMenu;
};

const agregarRutaDinamica = (item: MenuItemLateral, valoresDinamicos: ValoresPathDinamico[]): MenuItemLateral => {
	if (item.path && item.esPathDinamico) {
		let nuevoPath = item.path;
		valoresDinamicos.forEach(({ key, valor }) => {
			const regex = new RegExp(`:${key}`, 'g');
			nuevoPath = nuevoPath.replace(regex, valor);
		});
		item.path = nuevoPath;
	}
	if (item.items) {
		item.items = item.items.map((subItem) => agregarRutaDinamica(subItem, valoresDinamicos));
	}
	return item;
};

export const obtenerOpcionesMenuLateral = (menuLateral: MenuItemLateral[], rolActivo: Roles): MenuItemLateral[] => {
	return menuLateral.reduce((acumulador: MenuItemLateral[], item) => {
		if (item.rolesConAcceso.includes(rolActivo)) {
			const items = item.items?.filter((subItem) => subItem.rolesConAcceso.includes(rolActivo));
			acumulador.push({
				...item,
				items: items ? obtenerOpcionesMenuLateral(items, rolActivo) : undefined,
			});
		}
		return acumulador;
	}, []);
};
